import { render } from "./Index.vue?vue&type=template&id=5a2abb16&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5a2abb16&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=5a2abb16&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4027941633/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2abb16"]])

export default __exports__